<div mat-dialog-content>
  <div *ngFor="let quotation of quotationsList">
    <mat-card class="my-3">
      <mat-card-content>
        <div class="row">
          <div class="col-1">
            <input
              name="quotationsList"
              type="radio"
              [value]="quotation.PK"
              [(ngModel)]="selectedValue"
            />
          </div>
          <div class="col-11">
            <div class="row">
              <p class="col-md-6">
                <b>Cotización: </b
                >{{
                  quotation.rev !== 0
                    ? quotation.org.substr(4) + "-" + quotation.rev
                    : quotation.org.substr(4)
                }}
              </p>
              <p class="col-md-6"><b>Fecha: </b>{{ quotation.date }}</p>
              <p class="col-12"><b>Asunto: </b>{{ quotation.subject }}</p>
              <p class="col-12"><b>Alcance: </b>{{ quotation.scope }}</p>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-button (click)="send()">Seleccionar cotización</button>
</div>
